import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {NotesService} from "../../../services-otc/notes.service";
import {catchError, throwError} from "rxjs";
import {AttachmentModel} from "../../../models-otc/attachment-model";
import {AttachmentsService} from "../../../services-otc/attachments.service";


@Component({
    selector: 'app-replace-attachment',
    templateUrl: './edit-attachment.component.html',
    styleUrls: ['./edit-attachment.component.css'],
    standalone: false
})
export class EditAttachmentComponent implements OnInit{


  updateAttachmentForm: FormGroup;
  description: string
  fileName: string;

  attachments: AttachmentModel[];

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
               private updateAttachmentFb: FormBuilder,
               public dialogRef: MatDialogRef<OrderComponent>,
               private attachmentsService: AttachmentsService,
  ) {
    this.updateAttachmentForm = this.updateAttachmentFb.group({
      description: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.updateAttachmentForm.controls.description.setValue(this.data.description);
    this.fileName = this.data.fileName.length > 20 ? this.data.fileName.slice(0,15) + '...' : this.data.fileName;
  }

  cancelUpdatingAttachment(){
    this.dialogRef.close();
  }
  updateOrderAttachment() {
    if(this.data?.isLabManagerComp) {
      this.dialogRef.close({
        description: this.updateAttachmentForm.get('description').value
      });
    } else if(this.data.orderId){
      let attachmentObj = {
        id: this.data.attachmentID,
        description: this.updateAttachmentForm.get('description').value,
        orderId: this.data.orderId,
      };

      this.attachmentsService.updateAttachmentDescription(attachmentObj.id,attachmentObj.description).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

}
